import { Button } from "components"
import { TabRegisterPath } from "../types"
import { PERMISION } from "security"

type TabRegisterProps = {
  activeTab: string
  setActiveTab: (path: string) => void
}

type Tabs = {
  label: string
  path: TabRegisterPath
  permission: string
}

export function TabNavRegister({ activeTab, setActiveTab }: TabRegisterProps) {

  const tabs: Tabs[] = [
    { label: "REGISTER GROUP", path: "items-group", permission: PERMISION.INVENTORY.REGISTER.REGISTER_GROUP.PERMISION },
    { label: "TRANSFER", path: "items-transfer", permission: PERMISION.INVENTORY.REGISTER.TRANSFER.PERMISION },
    { label: "RECEIVED", path: "items-received", permission: PERMISION.INVENTORY.REGISTER.RECEIVED.PERMISION },
    { label: "COUNT", path: "items-count", permission: PERMISION.INVENTORY.REGISTER.COUNT.PERMISION },
    { label: "ADJUSTMENT", path: "items-adjustment", permission: PERMISION.INVENTORY.REGISTER.ADJUSTMENT.PERMISION },
    { label: "BUILD ITEM", path: "items-build", permission: PERMISION.INVENTORY.REGISTER.BUILD_ITEM.PERMISION },
    { label: "REQUEST FROM", path: "items-proces", permission: PERMISION.INVENTORY.REGISTER.REQUIEST_FROM.PERMISION },
  ]

  return (
    <section className="grow flex items-stretch overflow-x-auto sticky top-[85px] z-[1]">
      {tabs.map((tab) => (
        <Button
          key={tab.path}
          permission={tab?.permission}
          type="button"
          color="ghost"
          size="sm"
          className={`grow bg-[#3c3c3c] border-y-0 border-x no-animation hover:bg-primary hover:text-black whitespace-nowrap uppercase ${tab.path === activeTab ? "bg-primary text-black" : "text-white"}`}
          onClick={() => setActiveTab(tab.path)}
        >
          {tab.label}
        </Button>
      ))}
    </section>
  )
}
